/**
 * Grundbuchmeldung API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PolitischeGemeindeListEntry } from './politischeGemeindeListEntry';
import { MeldungsEmpfaengerId } from './meldungsEmpfaengerId';


export interface MeldungsEmpfaengerDetailEntry { 
    meldungsEmpfaengerId: MeldungsEmpfaengerId;
    modificationCounter?: number;
    bezeichnung?: string;
    sedexId?: string;
    erhaeltMeldungen?: boolean;
    erhaeltVertraulicheDaten?: boolean;
    erhaeltBasedelivery?: boolean;
    hasMeldungen?: boolean;
    schemaversion?: MeldungsEmpfaengerDetailEntry.SchemaversionEnum;
    registriertAufEreignisse?: Array<MeldungsEmpfaengerDetailEntry.RegistriertAufEreignisseEnum>;
    eingeschraenktAufGemeinden?: Array<PolitischeGemeindeListEntry>;
}
export namespace MeldungsEmpfaengerDetailEntry {
    export type SchemaversionEnum = 'ECH_0134_2_0';
    export const SchemaversionEnum = {
        ECH_0134_2_0: 'ECH_0134_2_0' as SchemaversionEnum
    };
    export type RegistriertAufEreignisseEnum = 'NEU_LIG_SDR' | 'LOESCHUNG_LIG_SDR' | 'AENDERUNG_LIG_SDR' | 'NEU_STW_MIT' | 'LOESCHUNG_STW_MIT' | 'AENDERUNG_STW_MIT' | 'NEU_EIGENTUM' | 'LOESCHUNG_EIGENTUM' | 'AENDERUNG_EIGENTUM' | 'NEU_ANMERKUNG' | 'LOESCHUNG_ANMERKUNG' | 'AENDERUNG_ANMERKUNG' | 'NEU_DIENSTBARKEIT' | 'LOESCHUNG_DIENSTBARKEIT' | 'AENDERUNG_DIENSTBARKEIT' | 'NEU_GRUNDLAST' | 'LOESCHUNG_GRUNDLAST' | 'AENDERUNG_GRUNDLAST' | 'NEU_VORMERKUNG' | 'LOESCHUNG_VORMERKUNG' | 'AENDERUNG_VORMERKUNG' | 'NEU_PFANDRECHT' | 'LOESCHUNG_PFANDRECHT' | 'AENDERUNG_PFANDRECHT';
    export const RegistriertAufEreignisseEnum = {
        NEU_LIG_SDR: 'NEU_LIG_SDR' as RegistriertAufEreignisseEnum,
        LOESCHUNG_LIG_SDR: 'LOESCHUNG_LIG_SDR' as RegistriertAufEreignisseEnum,
        AENDERUNG_LIG_SDR: 'AENDERUNG_LIG_SDR' as RegistriertAufEreignisseEnum,
        NEU_STW_MIT: 'NEU_STW_MIT' as RegistriertAufEreignisseEnum,
        LOESCHUNG_STW_MIT: 'LOESCHUNG_STW_MIT' as RegistriertAufEreignisseEnum,
        AENDERUNG_STW_MIT: 'AENDERUNG_STW_MIT' as RegistriertAufEreignisseEnum,
        NEU_EIGENTUM: 'NEU_EIGENTUM' as RegistriertAufEreignisseEnum,
        LOESCHUNG_EIGENTUM: 'LOESCHUNG_EIGENTUM' as RegistriertAufEreignisseEnum,
        AENDERUNG_EIGENTUM: 'AENDERUNG_EIGENTUM' as RegistriertAufEreignisseEnum,
        NEU_ANMERKUNG: 'NEU_ANMERKUNG' as RegistriertAufEreignisseEnum,
        LOESCHUNG_ANMERKUNG: 'LOESCHUNG_ANMERKUNG' as RegistriertAufEreignisseEnum,
        AENDERUNG_ANMERKUNG: 'AENDERUNG_ANMERKUNG' as RegistriertAufEreignisseEnum,
        NEU_DIENSTBARKEIT: 'NEU_DIENSTBARKEIT' as RegistriertAufEreignisseEnum,
        LOESCHUNG_DIENSTBARKEIT: 'LOESCHUNG_DIENSTBARKEIT' as RegistriertAufEreignisseEnum,
        AENDERUNG_DIENSTBARKEIT: 'AENDERUNG_DIENSTBARKEIT' as RegistriertAufEreignisseEnum,
        NEU_GRUNDLAST: 'NEU_GRUNDLAST' as RegistriertAufEreignisseEnum,
        LOESCHUNG_GRUNDLAST: 'LOESCHUNG_GRUNDLAST' as RegistriertAufEreignisseEnum,
        AENDERUNG_GRUNDLAST: 'AENDERUNG_GRUNDLAST' as RegistriertAufEreignisseEnum,
        NEU_VORMERKUNG: 'NEU_VORMERKUNG' as RegistriertAufEreignisseEnum,
        LOESCHUNG_VORMERKUNG: 'LOESCHUNG_VORMERKUNG' as RegistriertAufEreignisseEnum,
        AENDERUNG_VORMERKUNG: 'AENDERUNG_VORMERKUNG' as RegistriertAufEreignisseEnum,
        NEU_PFANDRECHT: 'NEU_PFANDRECHT' as RegistriertAufEreignisseEnum,
        LOESCHUNG_PFANDRECHT: 'LOESCHUNG_PFANDRECHT' as RegistriertAufEreignisseEnum,
        AENDERUNG_PFANDRECHT: 'AENDERUNG_PFANDRECHT' as RegistriertAufEreignisseEnum
    };
}


